import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import useTranslation from 'next-translate/useTranslation';

import { hooks as cabinetHooks } from '@/domains/cabinet/api';
import { langFormatter } from '@/utils/languageFormat';
import { actions } from '@/domains/cabinet/slice';

export const useAuthentication = () => {
  const { lang } = useTranslation();
  const formattedLang = langFormatter({ lang });
  const { push, pathname } = useRouter();
  const [trigger] = cabinetHooks.useGetAccounts();
  const dispatch = useDispatch();
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, isLoading] = useState(true);
  const checkUser = async () => {
    if (
      typeof window !== 'undefined' &&
      sessionStorage.getItem('refreshToken')
    ) {
      if (pathname.startsWith('/login')) {
        push('/cabinet');
      } else {
        try {
          const accounts = await trigger({
            lang: formattedLang,
          }).unwrap();
          sessionStorage.setItem('accountId', accounts[0].id);
          dispatch(actions.setAccounts(accounts));
          dispatch(actions.setSelectedAccountId(accounts[0].id));
          setLoggedIn(true);
        } catch (error) {
          // console.log();
        } finally {
          isLoading(false);
        }
      }
    } else {
      push('/login');
      sessionStorage.clear();
    }
  };

  useEffect(() => {
    checkUser();
  }, []);
  return { loading, loggedIn };
};
